import Logo from '@assets/logo.svg?react';
import LogoDark from '@assets/logo-dark.svg?react';
import { Box, Theme, useColorScheme } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import HeaderTags from '@components/common/HeaderTags';
import LoginForm from '@components/login/LoginForm';
import LoginSidebar from '@components/login/LoginSidebar';

function Login() {
 const { mode, systemMode } = useColorScheme();
 const resolvedMode = mode === 'system' ? systemMode : mode;
 const { t } = useTranslation();

 return (
  <>
   <HeaderTags title={t('login.title')} description={t('login.description')} />
   <Box
    sx={{
     width: '100%',
     minHeight: '100%',
     display: 'flex',
     p: { xs: 2, md: 5 },
    }}
   >
    <Box
     sx={{
      width: '100%',
      display: 'flex',
      overflow: 'hidden',
      background: (theme: Theme) => theme.palette.kemek.white,
      borderRadius: '20px',
     }}
    >
     <Box
      sx={{
       width: { xs: '100%', md: '50%' },
       display: 'flex',
       flexDirection: 'column',
       justifyContent: 'space-between',
       p: { xs: 2, md: 5 },
      }}
     >
      <Box
       sx={{
        display: 'flex',
        justifyContent: { xs: 'center', md: 'initial' },
        p: { xs: '12px', md: 0 },
        mb: { xs: 5, md: 0 },
       }}
      >
       {resolvedMode === 'light' && (
        <Link to="/">
         <Logo />
        </Link>
       )}

       {resolvedMode === 'dark' && (
        <Link to="/">
         <LogoDark />
        </Link>
       )}
      </Box>
      <LoginForm />
      <Box
       sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        fontSize: 12,
        color: (theme: Theme) => theme.palette.kemek.darkGray,
       }}
      >
       {t('login.copyright', { year: new Date().getFullYear() })}
      </Box>
     </Box>
     <LoginSidebar />
    </Box>
   </Box>
  </>
 );
}
export default Login;

